module.exports = __webpack_public_path__ + "img/look-krung-brew-konsuayjaidum.deed105e.png";